import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "../../../utils"
import { Tooltip } from "../Tooltip"

interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  success?: boolean
  error?: boolean
  disabled?: boolean
  tooltip?: string
}

function Label({
  error,
  success,
  disabled,
  className,
  tooltip,
  ...props
}: LabelProps) {
  return (
    <div className="flex gap-2">
      <LabelPrimitive.Root
        data-slot="label"
        className={cn(
          "text-primary-dark-blue flex items-center gap-2 leading-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 transition-colors",
          className,
          {
            "text-red": error,
            "text-primary-green": success,
            "opacity-30 cursor-not-allowed": disabled,
          },
        )}
        {...props}
      />

      {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </div>
  )
}

export { Label }
